import { render, staticRenderFns } from "./DeviceIcon.vue?vue&type=template&id=a12f691a&scoped=true"
import script from "./DeviceIcon.vue?vue&type=script&lang=js"
export * from "./DeviceIcon.vue?vue&type=script&lang=js"
import style0 from "./DeviceIcon.vue?vue&type=style&index=0&id=a12f691a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12f691a",
  null
  
)

export default component.exports